import { type BadgeIconProps, Icon } from "./Icon";
import { type BadgeLabelProps, Label } from "./Label";
import { type BadgePrefixImageProps, PrefixImage } from "./PrefixImage";
import { type BadgeRootProps, Root } from "./Root";

export const Badge = {
  Root,
  Label,
  Icon,
  PrefixImage,
};

export const BadgeRoot = Root;
export const BadgeLabel = Label;
export const BadgeIcon = Icon;
export const BadgePrefixImage = PrefixImage;

export type { BadgeIconProps, BadgeLabelProps, BadgePrefixImageProps, BadgeRootProps };
